import { getConnectionState, subscribeToConnectionState } from "@/game/services/ConnectionCache";
import { useEffect, useState } from "react";

export function ConnectionStatus() {
  const [status, setStatus] = useState(getConnectionState());

  useEffect(() => {
    const unsubscribe = subscribeToConnectionState((state) => {
      setStatus(state as "connected" | "disconnected");
    });
    return unsubscribe;
  }, []);

  // Remove DEGRADED state handling - binary connected/disconnected only
  const styles =
    status === "connected"
      ? { color: "text-green-500", bgColor: "bg-green-500", label: "Connected", pulse: false }
      : { color: "text-red-500", bgColor: "bg-red-500", label: "Disconnected", pulse: true };

  return (
    <div className="flex items-center gap-2 px-3 py-1.5 rounded-lg bg-gray-800/50 backdrop-blur-sm">
      <div className="relative">
        <div
          className={`w-2 h-2 rounded-full ${styles.bgColor} ${
            styles.pulse ? "animate-pulse" : ""
          }`}
        />
        {styles.pulse && (
          <div className={`absolute inset-0 w-2 h-2 rounded-full ${styles.bgColor} animate-ping`} />
        )}
      </div>
      <span className={`text-xs font-medium ${styles.color}`}>{styles.label}</span>
    </div>
  );
}
